// extracted by mini-css-extract-plugin
module.exports = {"cover":"styles_cover__Hp93G","showCover":"styles_showCover__16z63","hideCover":"styles_hideCover__2xl4h"};